import React, { useContext, useState, useEffect } from 'react'
import { Box, TextField, Button, Typography, FormControl, InputLabel, Select, MenuItem } from '@mui/material'
import { DataGrid } from '@mui/x-data-grid'
import Sidebar from './sidebar'
import CustomToolbar from './CustomToolbarPrint'
import DataContext from '../context/context'
import ProjectFilter from './ProjectFilter'
import { collection, getDocs } from 'firebase/firestore'
import { db } from '../firebase'
import { inDateRange, matchesProject } from '../utils/reportUtils'

export default function HomelessnessReport() {
  const dropDownData = useContext(DataContext)
  const [date1, setdate1] = useState('')
  const [date2, setdate2] = useState('')
  const [projectFilter, setprojectFilter] = useState([])
  const [statusFilter, setstatusFilter] = useState([])
  const [statusOptions, setstatusOptions] = useState([])
  const [rows, setRows] = useState([])
  const [rows1, setRows1] = useState([])

  const handleProjects = (projects) => {
    setprojectFilter(projects)
    setRows([])
    setRows1([])
  }

  useEffect(() => {
    if (Array.isArray(dropDownData?.housingStatusType)) {
      setstatusOptions(dropDownData.housingStatusType.filter(Boolean))
    }
  }, [dropDownData])

  const summaryColumns = [
    { field: 'status', headerName: 'Housing Journey Status', width: 300 },
    { field: 'count', headerName: 'Count', width: 150 },
  ]

  const columns = [
    { field: 'firstName', headerName: 'Name', width: 140 },
    { field: 'surName', headerName: 'Surname', width: 140 },
    { field: 'status', headerName: 'Housing Journey Status', width: 220 },
    { field: 'location', headerName: 'Location', width: 200 },
    { field: 'startDate', headerName: 'Start Date', width: 140 },
    { field: 'postCode', headerName: 'Postcode', width: 130 },
    { field: 'DOB', headerName: 'Date of Birth', width: 140 },
  ]

  const getData = async () => {
    if (projectFilter.length === 0) {
      setRows([])
      setRows1([])
      return
    }
    const q = collection(db, 'employee')
    const querySnapshot = await getDocs(q)

    const options = new Set(
      Array.isArray(dropDownData?.housingStatusType)
        ? dropDownData.housingStatusType
        : []
    )
    const details = []

    querySnapshot.forEach((document) => {
      const e = document.data()
      if (!matchesProject(e.gender, projectFilter)) return
      const houses = Array.isArray(e.house) ? e.house : []
      houses.forEach((h, i) => {
        if (!h || !h.status) return
        options.add(h.status)
        if (!inDateRange(h.date, date1, date2)) return
        if (statusFilter.length > 0 && !statusFilter.includes(h.status)) return
        details.push({
          id: `${document.id}-${i}`,
          firstName: e.firstName || '',
          surName: e.surName || '',
          status: h.status,
          location: h.location || '',
          startDate: h.date || '',
          postCode: e.postCode || '',
          DOB: e.DOB || '',
        })
      })
    })

    const sortedOptions = Array.from(options).filter(Boolean).sort()
    const statuses = statusFilter.length > 0 ? statusFilter : sortedOptions

    const summary = statuses.map((status) => ({
      id: status,
      status,
      count: details.filter((d) => d.status === status).length,
    }))
    summary.push({ id: 'total', status: 'Total', count: details.length })

    setstatusOptions(sortedOptions)
    setRows(details)
    setRows1(summary)
  }

  return (
    <Box sx={{ display: 'flex' }}>
      <Sidebar />
      <Box component="main" sx={{ flexGrow: 1, p: 3 }} style={{ marginTop: '50px' }}>
        <div style={{ width: '100%' }}>
          <ProjectFilter value={projectFilter} onChange={handleProjects} />
          <TextField type="date" InputLabelProps={{ shrink: true }} className="addform" label="Start Date" variant="outlined" style={{ width: '45%' }} onChange={(e) => setdate1(e.target.value)} value={date1} />
          <TextField type="date" InputLabelProps={{ shrink: true }} className="addform" label="End Date" variant="outlined" style={{ width: '45%' }} onChange={(e) => setdate2(e.target.value)} value={date2} />

          <FormControl className="addform" style={{ width: '90%', marginTop: '20px' }}>
            <InputLabel id="housing-status-label">Housing Journey Status</InputLabel>
            <Select
              multiple
              labelId="housing-status-label"
              id="housing-status"
              label="Housing Journey Status"
              value={statusFilter}
              onChange={(e) => setstatusFilter(e.target.value)}
              renderValue={(selected) => selected.join(', ')}
            >
              {statusOptions.map((status) => (
                <MenuItem key={status} value={status}>{status}</MenuItem>
              ))}
            </Select>
          </FormControl>

          <Button onClick={getData} disabled={projectFilter.length === 0} className="addform" variant="contained" style={{ marginBottom: '10px', width: '100%', height: '50px', marginTop: '30px', backgroundColor: '#F21D2F' }}>Search</Button>

          <Typography variant="h6" sx={{ mt: 2, mb: 1 }}>Overall Summary</Typography>
          <Typography variant="body2" sx={{ mb: 1, color: 'text.secondary' }}>
            Total housing entries: {rows1.find((row) => row.id === 'total')?.count || 0}
          </Typography>
          <div style={{ height: '35vh', marginBottom: '20px' }}>
            <DataGrid rows={rows1} columns={summaryColumns} pageSize={25} rowsPerPageOptions={[25]} components={{ Toolbar: CustomToolbar }} />
          </div>

          <Typography variant="h6" sx={{ mb: 1 }}>Breakdown</Typography>
          <div style={{ height: 440 }}>
            <DataGrid rows={rows} columns={columns} pageSize={10} rowsPerPageOptions={[5]} components={{ Toolbar: CustomToolbar }} />
          </div>
        </div>
      </Box>
    </Box>
  )
}
